(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vifon-waitlist"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.vifon-waitlist__form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var endpoint = form.getAttribute('data-waitlist-endpoint');
      if (!endpoint || !window.fetch) return; // native fallback: POST to Brevo's hosted page
      e.preventDefault();
      var msg = form.closest('.vifon-waitlist').querySelector('.vifon-waitlist__msg');
      var btn = form.querySelector('.vifon-waitlist__submit');
      btn.disabled = true;
      var url = endpoint + (endpoint.indexOf('?') > -1 ? '&' : '?') + 'isAjax=1';
      fetch(url, { method: 'POST', body: new FormData(form) })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          form.hidden = true;
          msg.textContent = form.closest('.vifon-waitlist').dataset.success;
          msg.hidden = false;
        })
        .catch(function () {
          btn.disabled = false;
          msg.classList.add('vifon-waitlist__msg--error');
          msg.textContent = 'Das hat leider nicht geklappt. Bitte versuche es gleich noch einmal.';
          msg.hidden = false;
        });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
